import * as d3 from 'd3';
import { Block } from '../types';
import { STYLES } from '../styles/constants';
import {
  getDecisionVisibleCharCap,
  splitDecisionTextIntoTwoLines,
} from './blockUtils';
import { getContentFitTextLines, isContentFitActive } from './blockTextLayout';

export function scaledDecisionFontSize(block: Block, width: number, height: number): number {
  const baseFont = block.textStyle?.fontSize || 12;
  const scale = Math.min(
    width / STYLES.decision.width,
    height / STYLES.decision.height
  );
  return Math.max(8, Math.min(28, Math.round(baseFont * scale)));
}

export function layoutDecisionDiamondText(
  svg: d3.Selection<SVGSVGElement, unknown, null, undefined>,
  decision: Block,
  width: number,
  height: number
) {
  if (decision.bpmnSymbol) return;

  const halfWidth = width / 2;
  const halfHeight = height / 2;
  const fontSize = scaledDecisionFontSize(decision, width, height);
  const lineHeight = fontSize * 1.2;
  const sizedBlock = {
    ...decision,
    width,
    height,
    textStyle: { ...decision.textStyle, fontSize },
  };
  const textLines = isContentFitActive(decision)
    ? getContentFitTextLines(sizedBlock)
    : splitDecisionTextIntoTwoLines(
        decision.text,
        getDecisionVisibleCharCap(fontSize, sizedBlock)
      );

  let text = svg.select<SVGTextElement>('text.decision-block-label');
  if (text.empty()) {
    text = svg.select<SVGTextElement>('text');
  }
  if (text.empty()) return;

  text.selectAll('tspan').remove();
  text
    .attr('x', halfWidth)
    .attr('y', textLines.length === 1
      ? halfHeight
      : halfHeight - ((textLines.length - 1) * lineHeight) / 2)
    .style('font-size', `${fontSize}px`);

  textLines.forEach((line, index) => {
    if (index === 0) {
      text.text(line);
    } else {
      text
        .append('tspan')
        .attr('x', halfWidth)
        .attr('dy', lineHeight)
        .attr('text-anchor', 'middle')
        .text(line);
    }
  });
}
